module.exports = __webpack_public_path__ + "fonts/ProximaNovaCondensedW05-LtIt.1962a896.ttf";